import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { SelectValidator, TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Button, Grid, MenuItem } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "../../../../../hooks/useForm";
import { InsertarOrigenErorrReclamoExterno, agregarComentarioExterno } from "../../../../../actions/reclamos/reclamosExternosActions";

const useStyles = makeStyles({
    botonera: {
      padding: 25,
    },
  });
  
  const FormInicial = {
    comentario: "",
  };


export const FormComentarioExterno = (props) => {
    const dispatch = useDispatch();
    const { tipoComentarios, origenErrorReclamo } = useSelector((state) => state.reclamos);
    const { solicitud, solicitudFinalizada } = props;
    const [formValues, handleInputChange] = useForm(FormInicial);
    const [idTipoComentario, setIdTipoComentario] = useState(2);
    const [idOrigenError, setIdOrigenError] = useState("");
    const classes = useStyles();
  
    const handleSave = () => {
      if (solicitudFinalizada === true) {
        const data = {
          idReclamo: solicitud,
          idOrigenErrorReclamo: idOrigenError
        }
        dispatch(InsertarOrigenErorrReclamoExterno(data))
      }
      dispatch(agregarComentarioExterno(solicitud, formValues.comentario, idTipoComentario));
      props.cerrarModal() || props.closeModalAuditar(false);
    };
  
  
  
    return (
      <ValidatorForm onSubmit={handleSave}>
        <Grid container spacing={2} style={{ padding: 25 }}>
          <Grid item xs={6} md={6}>
            {Array.isArray(tipoComentarios) && tipoComentarios?.length > 0 && (
              <SelectValidator
                fullWidth
                label="Tipo de Nota"
                name="idTipoComentario"
                value={idTipoComentario}
                //disabled={!!props.nota}
                onChange={(e) => setIdTipoComentario(e.target.value)}
                validators={["required"]}
                errorMessages={["Este campo es requerido"]}
              >
                {Array.isArray(tipoComentarios) &&
                  tipoComentarios?.length > 0 &&
                  tipoComentarios.map((tipoComen) => (
                    <MenuItem
                      key={tipoComen.id}
                      value={tipoComen.id}
                    >
                      {tipoComen.descripcion}
                    </MenuItem>
                  ))}
              </SelectValidator>
            )}
          </Grid>
          {solicitudFinalizada && (
            <Grid item xs={6} md={6}>
              {Array.isArray(origenErrorReclamo) && origenErrorReclamo?.length > 0 && (
                <SelectValidator
                  fullWidth
                  label="Origen Error"
                  name="idOrigenError"
                  value={idOrigenError}
                  //disabled={!!props.nota}
                  onChange={(e) => setIdOrigenError(e.target.value)}
                  validators={["required"]}
                  errorMessages={["Este campo es requerido"]}
                >
                  {Array.isArray(origenErrorReclamo) &&
                    origenErrorReclamo?.length > 0 &&
                    origenErrorReclamo.map((tipoError) => (
                      <MenuItem
                        key={tipoError.id}
                        value={tipoError.id}
                      >
                        {tipoError.descripcion}
                      </MenuItem>
                    ))}
                </SelectValidator>
              )}
            </Grid>
          )}
  
          <Grid item xs={12} md={12}>
            <TextValidator
              multiline
              rows={5}
              fullWidth
              variant="outlined"
              margin="normal"
              label="Descripcion"
              name="comentario"
              value={formValues.comentario}
              onChange={handleInputChange}
              validators={["required"]}
              errorMessages={["Este campo es obligatorio"]}
              InputLabelProps={{ style: { fontWeight: "bold" } }}
            />
          </Grid>
        </Grid>
        <Grid container className={classes.botonera}>
          <Grid item xs={12}>
            <Grid
              container
              spacing={1}
              direction="row"
              justify="flex-end"
              alignItems="center"
            >
              <Button
                variant="contained"
                color="secondary"
                size="small"
                startIcon={<CancelIcon />}
                onClick={props.cancelarModal}
              >
                CANCELAR
              </Button>
              {/* {
                                  (validarSoloUnPermiso(permisosUser, permisoAlta) || validarSoloUnPermiso(permisosUser, permisoEdit)) && */}
  
              <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<SaveIcon />}
                type="submit"
                style={{ marginLeft: "0.5rem" }}
              //onClick={props.cerrarModal}
              >
                GUARDAR
              </Button>
              {/* } */}
            </Grid>
          </Grid>
        </Grid>
      </ValidatorForm>
    )
  }
  